import { Icon, IconProps } from '@chakra-ui/react'

export default function ClinicIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M14.0024 14.0034V7.33394C14.0024 6.96559 13.7038 6.66699 13.3355 6.66699H10.6677"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.9975 14.0031V3.33198C1.9975 2.96364 2.2961 2.66504 2.66444 2.66504H10.0008C10.3692 2.66504 10.6678 2.96364 10.6678 3.33198V14.0031"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="8.16669"
        y="14.0029"
        width="3.66819"
        height="2.66778"
        transform="rotate(180 8.16669 14.0029)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33262 11.335V14.0027"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6694 14.0024H1.33051"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33262 6V8.00083"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33221 7.00046H7.33305"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
